<cx-generic-link
  *ngIf="displayProduct && variantProduct"
  [url]="{cxRoute: 'product', params: displayProduct} | cxUrl"
  class="focusable focusable__element">
  {{ variantProduct.name }}
</cx-generic-link>
